module.exports = __webpack_public_path__ + "img/tools_economy.9af875a0.png";